import { render, staticRenderFns } from "./DetailRightView.vue?vue&type=template&id=18daf8b3&scoped=true&"
import script from "./DetailRightView.vue?vue&type=script&lang=js&"
export * from "./DetailRightView.vue?vue&type=script&lang=js&"
import style0 from "./DetailRightView.vue?vue&type=style&index=0&id=18daf8b3&prod&lang=scss&scoped=true&"
import style1 from "./DetailRightView.vue?vue&type=style&index=1&id=18daf8b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18daf8b3",
  null
  
)

export default component.exports